/*
 * @Author: Teemo Ding
 * @Date: 2021-06-28 15:44:08
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-08-25 13:51:25
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelInvoice/OtherInformation/AddInformation/index.tsx
 */
import React, { Fragment, useState, useEffect } from 'react';
import { ModalFooter, Input, TextArea } from 'src/components/Antd';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import TopContainer from '@/src/components/Antd/Modal/TopContainer';
import CountWords from '@/src/components/CountWords/CountWords';
import { randomNumber } from '@/src/tools/helper';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

interface IProps {
  onCancel: () => void;
  onAdd: (value) => void;
  defaultData?: any;
}

const AddInformation = ({ onCancel, onAdd, defaultData }: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [contentError, setContentError] = useState(false);

  const onOk = () => {
    onAdd({ title, content, uuid: (defaultData || {}).uuid || randomNumber() });
  };
  useEffect(() => {
    if (defaultData) {
      setTitle(defaultData.title);
      setContent(defaultData.content);
    }
  }, [defaultData]);

  return (
    <Fragment>
      <TopContainer>
        <ItemWrapper
          title={getI18n('general.customer.title')}
          rightPart={
            <CountWords count={(title || '').length} allCount={100} />
          }>
          <Input
            maxLength={100}
            size='large'
            value={title}
            autoFocus
            onChange={(e) => {
              setTitle(e);
            }}
            error={contentError}
          />
        </ItemWrapper>
        <ItemWrapper
          title={`${getI18n('general.sider.content')}*`}
          rightPart={
            <CountWords count={(content || '').length} allCount={500} />
          }>
          <TextArea
            maxLength={500}
            size='large'
            value={content}
            onChange={(e) => {
              setContent(e);
              setContentError(false);
            }}
            error={contentError}
          />
        </ItemWrapper>
      </TopContainer>
      <ModalFooter
        okText={
          defaultData
            ? getI18n('general.saveChanges')
            : getI18n('general.linkModule.Modal.add')
        }
        onOk={onOk}
        onCancel={onCancel}
        hideOkButton={!content}
      />
    </Fragment>
  );
};
export default AddInformation;
